import React from 'react';
function IconSleep() {
  return <svg viewBox="0 0 48 48" width="20" height="20" className="shrink-0" data-id="element-373" data-mp="3m5q6apf5jgn4">
      <path d="M30 14 C22 14 16 20 16 28 C16 36 22 42 30 42 C25 38 22 33 22 27 C22 21 25 16 30 14 Z" fill="none" stroke="#8a7355" strokeWidth={1.6} strokeLinejoin="round" data-id="element-374" data-mp="b5s820kn8985" />
    </svg>;
}
function IconWaist() {
  return <svg viewBox="0 0 48 48" width="20" height="20" className="shrink-0" data-id="element-375" data-mp="1enu946peuew">
      <path d="M14 12 C14 20 22 22 24 24 C22 26 14 28 14 36" fill="none" stroke="#8a7355" strokeWidth={1.6} strokeLinecap="round" data-id="element-376" data-mp="3jksnnv2p5pez" />
      <path d="M34 12 C34 20 26 22 24 24 C26 26 34 28 34 36" fill="none" stroke="#8a7355" strokeWidth={1.6} strokeLinecap="round" data-id="element-377" data-mp="3nnp3je0ur7f8" />
    </svg>;
}
function IconAnxiety() {
  return <svg viewBox="0 0 48 48" width="20" height="20" className="shrink-0" data-id="element-378" data-mp="3elfruktul809">
      <path d="M24 24 m-10 0 a10 10 0 1 1 20 0 a7 7 0 1 1 -14 0 a4 4 0 1 1 8 0 a1.5 1.5 0 1 1 -3 0" fill="none" stroke="#8a7355" strokeWidth={1.6} strokeLinecap="round" data-id="element-379" data-mp="17vrn8dvau5zp" />
    </svg>;
}
function IconEnergy() {
  return <svg viewBox="0 0 48 48" width="20" height="20" className="shrink-0" data-id="element-380" data-mp="31gbm4i5zsisv">
      <circle cx={24} cy={24} r={14} fill="none" stroke="#33291c" strokeWidth={1.6} data-id="element-381" data-mp="31eihf8exw8ni" />
      <path d="M24 24 A14 14 0 0 1 34.9 33.6" fill="none" stroke="#8a7355" strokeWidth={1.6} strokeLinecap="round" data-id="element-382" data-mp="2wfnwo0xewa0r" />
      <circle cx={24} cy={24} r={2} fill="#8a7355" data-id="element-383" data-mp="367jwbgf5c873" />
    </svg>;
}
const symptoms = [{
  icon: IconSleep,
  title: 'Dormís pero no descansás.',
  subtitle: 'Ocho horas y aun así necesitás café para funcionar.'
}, {
  icon: IconWaist,
  title: 'Tu cintura cambió aunque comés parecido.',
  subtitle: 'La ropa que antes te quedaba bien hoy no cierra igual.'
}, {
  icon: IconAnxiety,
  title: 'Ansiedad, antojos e hinchazón.',
  subtitle: 'Aparecen a la tarde, sin aviso, y cuesta pararlos.'
}, {
  icon: IconEnergy,
  title: 'Te exigís igual pero tu cuerpo ya no responde igual.',
  subtitle: 'Ponés el mismo esfuerzo de siempre y los resultados ya no llegan.'
}];
export function SymptomsSection() {
  return <section className="bg-gradient-hero py-16 md:py-20 px-5 md:px-8" style={{
    paddingBottom: "0px"
  }} data-id="element-384" data-mp="2vlbohmxv2nq9">
      <div className="max-w-[1400px] mx-auto flex flex-col items-center text-center" data-id="element-385" data-mp="30k64yi8cw077">
        <div className="text-center max-w-md mx-auto" data-id="element-386" data-mp="34m042m2wkw59">
          <h3 className="font-display text-[32px] leading-tight text-foreground" data-id="element-387" data-mp="34nb3yat89jr3">
            ¿Te reconocés en alguna de estas situaciones?
          </h3>

          <ul className="mt-8 space-y-3 text-left" data-id="element-388" data-mp="2cv3rlmkr8tii">
            {symptoms.map((item, i) => {
            const Icon = item.icon;
            return <li key={i} className="font-body text-foreground/80 rounded-[10px] px-4 py-2.5 flex items-start gap-2.5" style={{
              border: '0.5px solid rgba(200,168,112,0.16)',
              background: 'rgba(255,255,255,0.02)'
            }} data-id="element-389" data-mp="2gxgrvvgqfz7w" data-mpi={i}>
                  <span className="mt-0.5" data-id="element-390" data-mp="1t6unqf9umz36">
                    <Icon data-id="element-391" data-mp="1t5t7zxhw1of4" />
                  </span>
                  <span data-id="element-392" data-mp="1y5xt60tqr7bo">
                    <p className="text-[17px] leading-snug" data-id="element-393" data-mp="1y5frgoob80wd">{item.title}</p>
                    <p className="text-[13.5px] text-foreground/55 mt-0.5 leading-snug" data-id="element-394" data-mp="1qmeqaa0zejc6">
                      {item.subtitle}
                    </p>
                  </span>
                </li>;
          })}
          </ul>

          {/* Imagen — cierre emocional del espejo, no apertura */}
          <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ChatGPT_Image_9_jun_2026_02_48_17_p.m_430x.jpg?v=1781031076" alt="Mujer reflexionando" loading="lazy" decoding="async" className="w-full max-w-[430px] mx-auto rounded-xl mt-10" data-id="element-395" data-mp="1gq3dlixhbrh7" />

          {/* Closing card — cierra el espejo emocional y da paso al cambio de creencia */}
          

          <div className="mt-10" data-id="element-396" data-mp="xyixvhig3dl7">
            <p className="font-display text-[34px] leading-tight text-foreground" data-id="element-397" data-mp="xvoabh44xcnk">
              No necesitás esforzarte más.
            </p>

            <p className="font-display italic text-[#C8A870] text-[30px] leading-tight mt-2" data-id="element-398" data-mp="oxcduygl7kn7">
              Necesitás entender qué cambió.
            </p>
            <div className="mt-8 mb-10 max-w-md mx-auto text-center" data-id="element-399" data-mp="k02pzn8ujh1h"></div>
          </div>
        </div>
      </div>
    </section>;
}